var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownFooterHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_644_10689)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.6004 6.35134L23.7815 5.52674C23.5238 5.26922 23.1809 5.12735 22.8144 5.12735C22.4482 5.12735 22.1049 5.26922 21.8471 5.52674L12.5056 14.8687L3.15328 5.51638C2.89596 5.25886 2.55266 5.11719 2.1864 5.11719C1.82014 5.11719 1.47664 5.25886 1.21912 5.51638L0.400003 6.3359C-0.133334 6.86883 -0.133334 7.73692 0.400003 8.26986L11.5351 19.4449C11.7924 19.7023 12.1353 19.8836 12.5048 19.8836H12.509C12.8755 19.8836 13.2184 19.7021 13.4757 19.4449L24.6004 8.30014C24.8581 8.04282 24.9996 7.68957 25 7.3233C25 6.95684 24.8581 6.60846 24.6004 6.35134Z",
    fill: "#9D6FD9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_644_10689"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownFooterHome);
export default __webpack_public_path__ + "static/media/Down-FooterHome.098fc2672591483f90151eeb24b13451.svg";
export { ForwardRef as ReactComponent };